// eslint-disable-next-line import/prefer-default-export
export const MAX_MSG_LENGTH = 7000
